import React, { useEffect, useState } from "react";
import { auth, db } from "../../../utils/firebase";

// UI components
import Partner from "../../../components/partner/partner";
import Table from "../../../components/structure/table/table";
import Checkbox from "../../../components/ui/checkbox/checkbox";
import { LoadingIcon } from "../../../utils/svgs";

// Hotels tab container for the partners page
export default function Hotels(props) {
    const [hotels, setHotels] = useState([]);
    const [hideConnected, setHideConnected] = useState(false);

    // On component load
    useEffect(() => {
        fetchHotelPartners();
    }, []);

    // Fetch the hotel partners from the database
    const fetchHotelPartners = async () => {
        // Query the database for the hotel partners
        db.collection("hotels")
            .orderBy("name")
            .get().then((queryDocs) => {
                // Store a local array of them to write to from the database query
                let hotelDocs = []

                // Loop over each partners and add them into the local array
                queryDocs.forEach((hotelDoc) => {
                    hotelDocs.push({ id: hotelDoc.id, ...hotelDoc.data(), })
                })

                // Then set them into the state
                setHotels(hotelDocs)
            })
    }

    return (
        <>
            {auth.currentUser.uid === 'CGOHCdUwFAOe13OSTY2D9qdO2LX2' && (
                <>
                    <Checkbox
                        label="Hide connected"
                        checked={hideConnected}
                        onClick={() => setHideConnected(!hideConnected)} />

                    <br />
                </>
            )}

            <Table
                className="partners-table"
                headings={[
                    "Name",
                    "Email",
                    "",
                    "",
                ]}>

                {(hotels.length === 0) &&
                    <div className="table-loading-splash">
                        <div className="loading-wrapper">
                            <p>Loading...</p>
                            <div className="svg-loading-wrap">
                                <LoadingIcon />
                            </div>
                        </div>
                    </div>
                }

                {hotels.map((partner) => (
                    <Partner
                        key={partner.id}
                        id={partner.id}
                        details={partner}
                        collection="hotels"
                        hideConnected={hideConnected}
                        showPartnerWindow={(partnerDoc) => props.setViewPartner(partnerDoc)} />
                    ))}
            </Table>
        </>
    );
}